<template>
    <div class="valid-invalid-column no-wrap">
      <o-icon pack="fas" :icon="value ? 'square-check' : 'circle-x'" :variant="value ? 'secondary' : 'danger'" />
    </div>
</template>

<script setup>

import {toRefs} from "vue";

const props = defineProps({
  row: {
    required: true,
  },
  value: {
    required: true,
  },
});
const {
  row,
    value,
} = toRefs(props);

</script>

<style scoped lang="scss">
    .valid-invalid-column {
        align-items: center;
        display: flex;
        justify-content: center;
        padding-top: 11px;
    }
</style>
